import { RxHome } from 'react-icons/rx'
import { BsSuitHeart, BsChatSquareText, BsChatText } from 'react-icons/bs'
import { MdSlowMotionVideo } from 'react-icons/md'
import { IoIosImages } from 'react-icons/io'
import { FiEdit } from 'react-icons/fi'
import { FaGlobeAmericas } from 'react-icons/fa'

import UserAppContext from '../../hook/UserAppContext'
import './aside.css'

const Aside = ({isCurrent, isSetCurrent}) => {

      const {user} = UserAppContext()
      const {infordata} = user.user 
      const AVATAR = `https://api.dicebear.com/5.x/initials/svg?seed=${infordata.name}&font-size=26`

      const setPage = (page) => {
            isSetCurrent(page)
      }

      return (
            <div className="aside_content">
                  <div className="aside_user">
                        <div className="user_avatar">
                              <img src={infordata.avatar === '' ? AVATAR : infordata.avatar} alt={infordata.name} />
                        </div>
                        <h1>{infordata.name}</h1>
                        <p>{infordata.status === '' ? "Undefined" : infordata.status}</p>
                  </div>
                  <div className="navigator">
                        <ul>
                              <li className={isCurrent === 'home' ? "navigator_item active" : "navigator_item"} onClick={() => setPage('home')}>
                                    <RxHome />
                                    <span>Home</span>
                              </li>
                              <li className={isCurrent === 'crush' ? "navigator_item active" : "navigator_item"} onClick={() => setPage('crush')}>
                                    <BsSuitHeart />
                                    <span>Crush</span>
                              </li>
                              <li className={isCurrent === 'video' ? "navigator_item active" : "navigator_item"} onClick={() => setPage('video')}>
                                    <MdSlowMotionVideo />
                                    <span>Video</span>
                              </li>
                              <li className={isCurrent === 'photo' ? "navigator_item active" : "navigator_item"} onClick={() => setPage('photo')}>
                                    <IoIosImages />
                                    <span>Photos</span>
                              </li>
                              <li className="navigator_item">
                                    <FiEdit />
                                    <a href={`https://xat.com/editme`} target="_blank" rel="noreferrer">Edit</a>
                              </li>
                        </ul>
                  </div>
                  <div className="nav_user">
                        <a href={infordata.homepage === '' ? "https://xat.com" : infordata.homepage} target="_blank" rel="noreferrer"><FaGlobeAmericas /></a>
                        <a href={infordata.xat_room === '' ? "https://xat.com" : infordata.xat_room} target="_blank" rel="noreferrer"><BsChatText /></a>
                        <a href={infordata.forum === '' ? "https://forum.xat.com" : infordata.forum} target="_blank" rel="noreferrer"><BsChatSquareText /></a>
                  </div>
            </div>
      )
}

export default Aside
